module.exports = __webpack_public_path__ + "static/media/rpd.faf835d6.jpg";